// src/sidebar/Navbar.js
import React, { useState } from 'react';
import { FaBars } from 'react-icons/fa';
import Nav from './Nav';

function Navbar() {
  const [sidebar, setSidebar] = useState(false);

  const toggleSidebar = () => setSidebar(prev => !prev);

  return (
    <>
      <button
        onClick={toggleSidebar}
        className="p-2 text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label="Open menu"
      >
        <FaBars className="text-2xl" />
      </button>

      <Nav sidebar={sidebar} toggleSidebar={toggleSidebar} />
    </>
  );
}

export default Navbar;